import { render, staticRenderFns } from "./SidebarParent.vue?vue&type=template&id=b9e9ff4c&"
import script from "./SidebarParent.vue?vue&type=script&lang=js&"
export * from "./SidebarParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports